import SearchUiDomJQueryBuilder from './SearchUiDomJQueryBuilder';

/**
 * SearchUiDom
 * @constructor
 */
function SearchUiDom() {
    var domConfigs = {
        document: {
            selector: 'document',
            methods: [{ type: 'bindAndUnBindDomEvents' }],
        },
        body: {
            selector: 'body',
            methods: [
                {
                    type: 'simpleCall',
                    methodName: 'getScrollPosition',
                    libraryMethodName: 'scrollTop',
                },
                {
                    type: 'simpleCall',
                    methodName: 'setScrollPosition',
                    libraryMethodName: 'scrollTop',
                },
            ],
        },
        mainOffCanvas: {
            selector: '#main-off-canvas',
            methods: [
                {
                    type: 'toggleClass',
                    addClassMethodName: 'fix',
                    removeClassMethodName: 'unfix',
                    className: 'off-canvas--fixed',
                },
            ],
        },
        overlay: {
            selector: '#search-overlay',
            methods: [
                {
                    type: 'toggleClass',
                    addClassMethodName: 'restoreInitialState',
                    removeClassMethodName: 'removeInitialState',
                    className: 'search-overlay--initial',
                },
                {
                    type: 'toggleClass',
                    addClassMethodName: 'show',
                    removeClassMethodName: 'hide',
                    className: 'search-overlay--visible',
                },
                { type: 'bindAndUnBindDomEvents' },
            ],
        },
        innerOverlay: {
            selector: '.search-overlay__inner',
            methods: [
                { type: 'extendHeightWith' },
                {
                    type: 'simpleCall',
                    methodName: 'resetHeight',
                    libraryMethodName: 'height',
                    libraryMethodParam: '100%',
                },
            ],
        },
        sidebar: {
            selector: '#desktop-sidebar',
            descendantOf: 'mainOffCanvas',
            methods: [{ type: 'bindAndUnBindDomEvents' }],
        },
        open: {
            selector: '#nav-Search a, ' +
            '#carousel .navSearch a, ' +
            '#toolbar .navSearch, ' +
            '.c-ios-search .c-ios-search__fake-input,' +
            '#header a.header__search',
            methods: [{ type: 'bindAndUnBindDomEvents' }],
        },
        close: {
            selector: '#search-close',
            descendantOf: 'overlay',
            methods: [{ type: 'bindAndUnBindDomEvents' }],
        },
        input: {
            selector: '#search-input',
            descendantOf: 'overlay',
            methods: [
                {
                    type: 'simpleCall',
                    methodName: 'focus',
                    libraryMethodName: 'focus',
                },
                {
                    type: 'simpleCall',
                    methodName: 'clearValue',
                    libraryMethodName: 'val',
                    libraryMethodParam: '',
                },
                {
                    type: 'simpleCall',
                    methodName: 'setValue',
                    libraryMethodName: 'val',
                },
                {
                    type: 'simpleCall',
                    methodName: 'triggerChange',
                    libraryMethodName: 'trigger',
                    libraryMethodParam: 'input.search.input',
                },
            ],
        },

        eventsContainer: {
            selector: '.search-events',
            descendantOf: 'overlay',
            methods: [
                {
                    type: 'toggleClass',
                    addClassMethodName: 'show',
                    removeClassMethodName: 'hide',
                    className: 'search-events--has-results',
                },
            ],
        },
        eventsResults: {
            selector: '.search-events__list',
            descendantOf: 'eventsContainer',
            methods: [
                {
                    type: 'simpleCall',
                    methodName: 'setContent',
                    libraryMethodName: 'html',
                },
                {
                    type: 'simpleCall',
                    methodName: 'appendContent',
                    libraryMethodName: 'append',
                },
                {
                    type: 'toggleClass',
                    addClassMethodName: 'showScrollMask',
                    removeClassMethodName: 'hideScrollMask',
                    className: 'search-events__list--more-results',
                },
                { type: 'bindAndUnBindDomEvents' },
            ],
        },
        eventsCount: {
            selector: '.search-events__count',
            descendantOf: 'eventsContainer',
            methods: [
                {
                    type: 'simpleCall',
                    methodName: 'setContent',
                    libraryMethodName: 'html',
                },
            ],
        },

        quickLinksContainer: {
            selector: '.search-quick-links',
            descendantOf: 'overlay',
            methods: [
                {
                    type: 'toggleClass',
                    addClassMethodName: 'show',
                    removeClassMethodName: 'hide',
                    className: 'search-quick-links--has-results',
                },
            ],
        },
        quickLinksResults: {
            selector: '.search-quick-links__list',
            descendantOf: 'quickLinksContainer',
            methods: [
                {
                    type: 'simpleCall',
                    methodName: 'setContent',
                    libraryMethodName: 'html',
                },
                { type: 'bindAndUnBindDomEvents' },
            ],
        },
        quickLinksCount: {
            selector: '.search-quick-links__count',
            descendantOf: 'quickLinksContainer',
            methods: [
                {
                    type: 'simpleCall',
                    methodName: 'setContent',
                    libraryMethodName: 'html',
                },
            ],
        },

        recentSearchesContainer: {
            selector: '.search-recent',
            descendantOf: 'overlay',
            methods: [{ type: 'showAndHide' }],
        },
        recentSearchesResults: {
            selector: '.search-recent__list',
            descendantOf: 'recentSearchesContainer',
            methods: [
                {
                    type: 'simpleCall',
                    methodName: 'setContent',
                    libraryMethodName: 'html',
                },
                { type: 'bindAndUnBindDomEvents' },
            ],
        },

        notFoundMessage: {
            selector: '.search-overlay__results-not-found',
            descendantOf: 'overlay',
            methods: [{ type: 'showAndHide' }],
        },
        error: {
            selector: '.search-overlay__error-msg',
            descendantOf: 'overlay',
            methods: [{ type: 'showAndHide' }],
        },
        progress: {
            selector: '.search-overlay__loader',
            descendantOf: 'overlay',
            methods: [{ type: 'showAndHide' }],
        },
        addedToSlipSuccessMessage: {
            selector: '.add-to-slip-confirmation__added',
            methods: [
                {
                    type: 'toggleClass',
                    addClassMethodName: 'show',
                    removeClassMethodName: 'hide',
                    className: 'add-to-slip-confirmation__added--animate',
                },
                {
                    type: 'simpleCall',
                    methodName: 'redraw',
                    libraryMethodName: 'offset',
                },
            ],
        },
        removedFromSlipSuccessMessage: {
            selector: '.add-to-slip-confirmation__removed',
            methods: [
                {
                    type: 'toggleClass',
                    addClassMethodName: 'show',
                    removeClassMethodName: 'hide',
                    className: 'add-to-slip-confirmation__removed--animate',
                },
                {
                    type: 'simpleCall',
                    methodName: 'redraw',
                    libraryMethodName: 'offset',
                },
            ],
        },
    };

    this.domBuilder = new SearchUiDomJQueryBuilder(domConfigs, this).buildDom();
}

//@TODO[el] Consider moving to adapter as discussed with Janos C
/**
 * Considers if the ViewPort is small or not
 *
 * @return {boolean}
 */
SearchUiDom.prototype.isSmallViewPort = function () {
    return document.body.offsetWidth <= 479 || document.body.offsetHeight <= 479;
};

export default SearchUiDom;
